<template>
    <div class="detail-status-wrapper">
        <div :class="{ del: status.isActive }">{{ status.value }}</div>
    </div>
</template>

<script>
export default {
    name: "ClusterDetailStatusColumn",
    props: ["row"],
    computed: {
        status() {
            let status = this.row.addData.status;
            return {
                isActive: status === this.$t("zhiji.cluster.logDetail.deleted") ? true : false,
                value: status
            };
        }
    }
};
</script>

<style lang="scss" scoped>
.detail-status-wrapper {
    .del {
        color: #9b9ba3;
    }
}
</style>
